class MobileMenu {
    constructor() {
        this.menu = document.querySelector(".site-header__menu");
        this.openButton = document.querySelector(".site-header__menu-trigger");
        this.menuItems = document.querySelectorAll(".site-header__menu .menu-item a");
        this.scrollPosition = 0; // Salva la posizione di scorrimento corrente
        this.events();
    }

    events() {
        this.openButton.addEventListener("click", () => this.toggleMenu());
        this.menuItems.forEach(item => {
            item.addEventListener("click", () => this.closeMenu());
        });
    }

    toggleMenu() {
        this.openButton.classList.toggle("bi-list");
        this.openButton.classList.toggle("bi-x-lg");

/*        this.openButton.classList.toggle("fa-bars");
        this.openButton.classList.toggle("fa-times");*/
        this.menu.classList.toggle("site-header__menu--active");

        // Salva la posizione di scorrimento corrente prima di aprire il menu
        this.scrollPosition = window.scrollY;

        // Aggiungi o rimuovi il blocco dello scrolling a seconda dello stato del menu
        document.body.style.overflow = this.menu.classList.contains("site-header__menu--active") ? "hidden" : "auto";
    }

    closeMenu() {
        if (this.menu.classList.contains("site-header__menu--active") && window.location.href.includes("shop")) {
            // Ripristina la posizione di scorrimento al momento della chiusura del menu
            window.scrollTo(0, this.scrollPosition);
            this.toggleMenu();
        }
    }
}

export default MobileMenu;
